import { envConfig } from "@/config/env";
import { storageManager } from "@/services/storage/storage/storage";
import { stripTrailingSlash } from "@/utils/url";

const STORAGE_KEY = "graphql-url-override";

export const graphqlUrlOverrideStorage = {
  async get(): Promise<string | null> {
    try {
      await storageManager.initialize();
      const value = await storageManager.getAppState<string>(STORAGE_KEY);
      return value?.trim() || null;
    } catch (error) {
      console.error("Failed to retrieve GraphQL URL override:", error);
      return null;
    }
  },

  async set(url: string): Promise<void> {
    await storageManager.initialize();
    await storageManager.setAppState(STORAGE_KEY, url.trim());
  },

  async clear(): Promise<void> {
    await storageManager.initialize();
    await storageManager.deleteAppState(STORAGE_KEY);
  },
};

/**
 * Resolves the GraphQL base URL, preferring a locally stored developer
 * override (set via the API Config debug tab) over the build-time env var.
 * Only the URL differs -- auth (tokens, headers) is untouched.
 */
export async function getEffectiveGraphqlBaseUrl(): Promise<string> {
  const override = await graphqlUrlOverrideStorage.get();
  return stripTrailingSlash(override || envConfig.graphqlBaseUrl);
}
